import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useMemo } from 'react';
import { NumericFormat } from 'react-number-format';
import { moneyFormat } from '@circlefin/money';
import { Input } from '../../Input/Input.es.js';
import { InputContext } from '../../Input/Input.Context/Input.Context.es.js';

const MoneyInputInner = /*#__PURE__*/ forwardRef(({ name, padded, locale = 'en-US', currencyConfig, disableCurrencySymbol = false, disableCurrencyVariant = false, onChange, onBlur, onKeyUp, onKeyDown, ...rest }, ref)=>{
    const { id, inputLabelId, inputMessageId, value, disabled, placeholder, readOnly } = useContext(InputContext);
    // Derive number formatting properties
    const { currencyCode, numberParts, meta } = useMemo(()=>moneyFormat(10000.1, currencyConfig, locale) || {}, [
        locale,
        currencyConfig
    ]);
    const showCurrencySymbol = useMemo(()=>{
        return !disableCurrencySymbol && meta?.currencyDisplay === 'symbol' && numberParts?.get.currency !== undefined;
    }, [
        disableCurrencySymbol,
        numberParts,
        meta
    ]);
    return jsxs(Input.Field.Custom, {
        children: [
            jsx(NumericFormat, {
                allowNegative: false,
                "aria-describedby": inputMessageId,
                "aria-labelledby": inputLabelId,
                className: "input",
                "data-testid": "number-input",
                decimalScale: meta?.maximumFractionDigits,
                decimalSeparator: numberParts?.get.decimal,
                disabled: disabled,
                fixedDecimalScale: padded,
                getInputRef: ref,
                id: id,
                name: name,
                onBlur: onBlur,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onValueChange: onChange,
                placeholder: placeholder,
                readOnly: readOnly,
                thousandSeparator: numberParts?.get.group,
                value: value,
                ...rest
            }),
            !disableCurrencyVariant && jsx(Input.Inline.Affix, {
                "data-testid": "currency-variant",
                variant: "suffix",
                children: currencyCode
            }),
            showCurrencySymbol && jsx(Input.Inline.Affix, {
                "data-testid": "currency-symbol",
                variant: "prefix",
                children: numberParts?.get.currency
            })
        ]
    });
});
MoneyInputInner.displayName = 'MoneyInput.Inner';

export { MoneyInputInner, MoneyInputInner as default };
//# sourceMappingURL=MoneyInput.Inner.es.js.map
